import React, { useState } from 'react';
import cx from 'classnames';

interface AccordionProps {
  title: string | JSX.Element;
  classNames?: string;
  children?: JSX.Element;
  active?: boolean;
  bgGradient?: string;
}

const Accordion = ({ title, children, classNames, active = false, bgGradient }: AccordionProps) => {
  const [open, setOpenState] = useState(active);
  const toggleAccordian = () => setOpenState(prevState => !prevState);
  return (
    <div style={{marginTop:"2rem"}}>
      {title !== "" && 
       <div
       className={`relative ${
         bgGradient === 'Blue Gradient' ? 'sky-blue-gradient text-white' : 'sky-bg-gray-light sky-text-midnight'
       } text-left h-20 px-8 py-4 md:p-4 flex items-center cursor-pointer ${classNames}`}
       onClick={toggleAccordian}>
       <div className="flex-1 pr-8 sky-h6-bold md:sky-h4-bold">{title}</div>
       <button
         type="button"
         aria-expanded={open}
         onClick={(event) => {
           event.stopPropagation();
           toggleAccordian();
         }}
         className="ml-auto h-20 w-12 flex items-center justify-center sky-h3 md:sky-h4 bg-transparent border-none cursor-pointer"
       >
         {open ? '-' : '+'}
       </button>
     </div>}
      <div className={cx('transition-all', { 'h-auto overflow-visible': open, 'h-0 overflow-hidden': !open })}>
        {children}
      </div>
    </div>
  );
};

export { Accordion };
